import { render, staticRenderFns } from "./ProductCreationRules.vue?vue&type=template&id=7819c9aa&scoped=true"
var script = {}
import style0 from "./ProductCreationRules.vue?vue&type=style&index=0&id=7819c9aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7819c9aa",
  null
  
)

export default component.exports